import { useButtonState } from '../hooks/useButtonState';
import { useNewsletterForm } from '../hooks/useNewsletterForm';
import SuccessStateComponent from './SuccessState';
import ErrorStateComponent from './ErrorState';

const NewsletterFormContainer = (props: any) => {
	const { ErrorState, SuccessState, blockClass, componentId } = useNewsletterForm();
	const { state, setState } = useButtonState();

	//nao consegui obter o html padrao do loading para fazer

	const renderClass = () => {
		return blockClass && `newsletterForm--${blockClass} vtex-store-newsletter-1-x-newsletterForm--${blockClass} `;
	};
	if (state == 'clicked')
		return <SuccessStateComponent onClickHandler={() => setState('error')} {...{ SuccessState, blockClass }} />;
	// if (state == "loading") return <LoadingState/>;
	if (state == 'error')
		return <ErrorStateComponent onClickHandler={() => setState('default')} {...{ ErrorState, blockClass }} />;
	return (
		<div
			data-selection={componentId}
			className={`newsletterForm ${renderClass()} vtex-store-newsletter-1-x-newsletterForm`}
		>
			{props.children}
		</div>
	);
};

export default NewsletterFormContainer;
